// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ninput[type=\"text\"] { /*width:180px;*/ padding:4px 5px 4px 5px; margin:0px;\n}\n", ""]);
// Exports
module.exports = exports;
